import request from '@/utils/request'

// 软件版本分页
export function qryFeedback(query) {
  return request({
    url: '/admin/feedback/page',
    method: 'get',
    params: query
  })
}

// 处理意见反馈
export function addFeedback(data) {
  return request({
    url: '/admin/feedback/update',
    method: 'put',
    data
  })
}
